const initialState = {
  bookingResult: {
  },
};

// 提交订单
export default function receiveBookingResult(state = initialState, action) {
  switch (action.type) {
  case 'SHOW_CREATE_ORDER':
    return { ...state, bookingResult: action.payload };
  default:
    return state;
  }
}